export default "__VITE_ASSET__kWIWtAnI__"